import React, { useState } from "react";
import withAuth from "@/components/auth/withAuth";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { signUp } from "@/axios";
import { useRouter } from "next/router";
import Link from "next/link";
import { useForm } from "react-hook-form";
import { signUpValidationSchema } from "@/components/utility/validationSchemeas";
import { yupResolver } from "@hookform/resolvers/yup";
import LoadingButton from "@/components/shared/button/loadingButton/LoadingButton";
import { motion } from "framer-motion";
import { routesURL } from "@/components/urls";
import useTitle from "@/components/hooks/useTitle";
import useToast from "@/components/shared/snackBar/useToast";
import BlocksetUppercaseLogo from "@/components/assets/logo/BlocksetUppercaseLogo";
const SignUp = () => {
  useTitle("Sign Up");
  const {
    handleSubmit,
    register,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
      confirmPassword: "",
      showPassword: false,
    },
    resolver: yupResolver(signUpValidationSchema),
  });

  const [isLoading, setIsLoading] = useState(false);
  const [showVerfication, setShowVerification] = useState(false);
  const router = useRouter();
  const { enqueueSnackbar } = useToast();

  const showPassword = watch("showPassword");
  const email = watch("email");
  const handleClick = async (data, e) => {
    e.preventDefault();
    setIsLoading(true);
    const { email, password } = data;
    const formData = new URLSearchParams();
    formData.append("username", email);
    formData.append("password", password);
    try {
      const { status, data } = await signUp(formData);
      if (status === 200) {
        enqueueSnackbar("Successfully created user", "success");
        setShowVerification(true);
        // router.push(routesURL.login);
      }
    } catch (error) {
      const { response = {} } = error;
      const { status, data } = response;
      if (status) {
        enqueueSnackbar(data?.detail || "Something went wrong", "error");
      }
      setIsLoading(false);
    }
  };
  return (
    <div className=" !min-h-[calc(100vh)] flex items-center justify-center max-sm:p-4 main-container bg-white">
      <motion.form
        onSubmit={handleSubmit(handleClick)}
        initial={{ scale: 0.3, opacity: 0.4 }}
        animate={{ scale: 1, opacity: 1 }}
        className=" bg-white min-h-[80vh] w-[450px] max-md:min-w-[350px] max-sm:min-w-[200px] rounded-3xl px-[30px] py-[40px]"
      >
        <div className=" flex items-center justify-center">
          <BlocksetUppercaseLogo height={"35px"} width={"auto"} />
        </div>
        {showVerfication ? (
          <>
            <div className="mt-14 text-center">
              <div className=" text-[20px] font-bold">Verify Email Address</div>
              <div className="  text-[14px]  text-center mt-7">
                You are alomst there! We have sent an email to <br />
                {email}
              </div>
              <div className=" text-[14px] text-center mt-7">
                Just click on the link in the email to complete signup
              </div>
              <div>
                <Link href={routesURL.login}>
                  <span className=" cursor-pointer underline">Login</span>
                </Link>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className=" text-center font-light mt-16 text-black-1">
              <h2 className=" text-5xl font-semibold leading-tight">
                create your account
              </h2>
              <p className=" mt-8 text-2xl">
                Join the AI powered analytics platform
              </p>
            </div>
            <div className="mt-[30px]">
              <div className="">
                <input
                  type="email"
                  {...register("email")}
                  placeholder="Enter your email"
                  className=" w-full p-4 outline-none border border-neutral-300 rounded-lg text-2xl appearance-none"
                />
                {errors?.email?.message !== "" && (
                  <p className="text-red-500 mt-2">{errors?.email?.message}</p>
                )}
              </div>
              <div className=" mt-10 relative">
                <input
                  type={showPassword ? "text" : "password"}
                  {...register("password")}
                  placeholder="Enter your password"
                  className=" w-full p-4 outline-none border border-neutral-300 rounded-lg text-2xl appearance-none"
                />
                {errors?.password?.message !== "" && (
                  <p className="text-red-500 mt-2">
                    {errors.password?.message}
                  </p>
                )}
                <div
                  className=" absolute right-4 top-[8px] cursor-pointer"
                  onClick={() => setValue("showPassword", !showPassword)}
                >
                  {showPassword ? (
                    <AiOutlineEyeInvisible size={24} />
                  ) : (
                    <AiOutlineEye size={24} />
                  )}
                </div>
              </div>
              <div className=" mt-10">
                <input
                  type={"password"}
                  {...register("confirmPassword")}
                  placeholder="Re-enter your password"
                  className=" w-full p-4 outline-none border border-neutral-300 rounded-lg text-2xl appearance-none"
                />
              </div>
              {errors?.confirmPassword?.message && (
                <p className="text-red-500 mt-2">
                  {errors?.confirmPassword?.message}
                </p>
              )}
              <LoadingButton
                isLoading={isLoading}
                loaderHeight={20}
                loaderWidth={20}
                type="submit"
                classes=" w-full py-4 text-2xl mt-10 text-white rounded-lg bg-slate-950"
              >
                Sign up
              </LoadingButton>
            </div>
            <div className=" mt-7 text-center text-black-1">
              {"Already a member?"}{" "}
              <Link href={routesURL.login}>
                <span className=" cursor-pointer underline">Login</span>
              </Link>
            </div>
          </>
        )}
      </motion.form>
    </div>
  );
};

export default SignUp;

export const getServerSideProps = withAuth((context) => {
  return {
    props: {},
  };
});
